import { WarehouseFacade } from '@pf/platform-wms/domain';
import { inject, Injectable } from '@angular/core';
import { map } from 'rxjs';
import {
    CoreProviderConfig,
    UserPositionContextProvider,
} from '@pf/platform-core/domain';

@Injectable()
export class CpwUserPositionContextProvider
    implements UserPositionContextProvider
{
    private readonly warehouseFacade = inject(WarehouseFacade);

    getContext$(_?: string) {
        return this.warehouseFacade.active$.pipe(
            map(warehouse => ({
                warehouseId: warehouse?.id,
                locationId: warehouse?.location?.id ?? warehouse?.locationId,
            }))
        );
    }
}

export const coreProviderConfig: CoreProviderConfig = {
    userPositionContextProvider: CpwUserPositionContextProvider,
};
